// extracted by mini-css-extract-plugin
export var drawerPaper = "_3o-0";
export var itemCard = "_3o-1";
export var itemImage = "_3o-2";